import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { ArrowDown, ArrowRight, ClipboardList, ShieldCheck, Mic, Headphones, Send } from "lucide-react";

export const PIPELINE = [
  { n: 1, Icon: ClipboardList, title: "Request a Quote", text: "Fill out the intake form with your name, email, and include any details, links, stems, or questions you have for your project. I'll review your creative brief and send a transparent project quote within 24 hours." },
  { n: 2, Icon: ShieldCheck, title: "Secure Retainer", text: "Once the quote is approved, we secure your slot on the studio calendar with a standard 50% project deposit." },
  { n: 3, Icon: Mic, title: "Tracking & Engineering", text: "I step into the booth to record your performances on the Rode NT1 capsule, then move to the REAPER mastering suite to clean up transients and build custom FX chains." },
  { n: 4, Icon: Headphones, title: "Review Copy", text: "You receive a protected, watermarked review copy of the tracks to audit the performance, pacing, and overall mix. Every project includes two full rounds of adjustments." },
  { n: 5, Icon: Send, title: "Master Delivery", text: "Upon approval of the final mix and settlement of the remaining invoice, your broadcast-ready, high-fidelity MP3/WAV files are instantly delivered via secure links." },
];

export const HowItWorksButton = ({ testId = "how-it-works-btn", className = "" }) => {
  const [open, setOpen] = useState(false);
  const startQuote = () => {
    setOpen(false);
    setTimeout(() => window.dispatchEvent(new CustomEvent("eovo:open-quote")), 120);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" aria-label="How it works" title="How it works" data-testid={testId}
          className={`inline-flex items-center justify-center h-6 w-6 rounded-full bg-[#C8A97E]/15 border border-[#C8A97E]/50 text-[#C8A97E] text-sm font-bold leading-none hover:bg-[#C8A97E] hover:text-[#0B0C10] hover:scale-110 transition-all shrink-0 ${className}`}>
          ?
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#12141A] border-white/10 text-white max-w-md max-h-[85vh] overflow-y-auto" data-testid="how-it-works-dialog">
        <DialogHeader>
          <DialogTitle className="font-head text-2xl">How It Works</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#A1A1AA] leading-relaxed">A clear, five-step workflow from your first message to broadcast-ready delivery.</p>
        <div className="mt-2">
          {PIPELINE.map((step, i) => (
            <React.Fragment key={step.n}>
              <div data-testid={`hiw-step-${step.n}`} className="flex gap-3 items-start rounded-xl border border-white/10 bg-[#0B0C10] p-3.5">
                <div className="relative h-10 w-10 rounded-lg bg-[#C8A97E]/10 border border-[#C8A97E]/30 flex items-center justify-center shrink-0">
                  <step.Icon size={18} className="text-[#C8A97E]" />
                  <span className="absolute -top-2 -right-2 h-5 w-5 rounded-full bg-[#C8A97E] text-[#0B0C10] text-[11px] font-bold flex items-center justify-center">{step.n}</span>
                </div>
                <div className="min-w-0">
                  <h4 className="font-head text-base font-medium leading-tight">{step.title}</h4>
                  <p className="text-xs text-[#A1A1AA] leading-relaxed mt-1">{step.text}</p>
                  {step.n === 1 && (
                    <button type="button" onClick={startQuote} data-testid="hiw-start-quote"
                      className="mt-2.5 inline-flex items-center gap-1.5 text-xs font-semibold bg-[#C8A97E] text-[#0B0C10] px-3 py-1.5 rounded-sm hover:bg-[#B3956D] transition-colors">
                      Request a Quote <ArrowRight size={13} />
                    </button>
                  )}
                </div>
              </div>
              {i < PIPELINE.length - 1 && (
                <div className="flex justify-center py-1 text-[#C8A97E]/60" aria-hidden="true">
                  <ArrowDown size={20} />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="mt-3 rounded-lg border border-[#C8A97E]/20 bg-[#C8A97E]/[0.06] p-3 text-xs text-[#A1A1AA] leading-relaxed">
          <span className="text-[#C8A97E] font-semibold">Payments:</span> Interac e-Transfer for Canadian clients · Square for US &amp; international clients.
        </div>
      </DialogContent>
    </Dialog>
  );
};
